module.exports = __webpack_public_path__ + "img/custom.bb1dc42c.svg";